export const MAX_LENGTH_PRACTICE_ID = 16;
export const MIN_LENGTH_PRACTICE_ID = 8;
export const allowedChars = new RegExp(`^[\\u0020-\\u007E\\u00C0-\\u02AF\\u0370-\\u1FFF\\u2E80-\\uD7AF\\uF900-\\uFEFF]{${MIN_LENGTH_PRACTICE_ID},${MAX_LENGTH_PRACTICE_ID}}$`);